module.exports = require('@wix/communities-universal/dist/src/services/editor-content-text');
